import { themeColor } from 'src/mui-theme';
import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    background: themeColor.modalBackground,
  },
  title: {
    color: themeColor.defaultTextColor,
  },
  instructions: {
    color: themeColor.primaryMain,
    fontSize: rem(1.1),
    '@media(width:1024px) and (height:576px)': {
      fontSize: rem(0.9),
    },
  },
  mainContainer: {
    margin: '2% 2%',
    '@media(width:1024px) and (height:576px)': {
      margin: '1% 2%',
    },
  },
  titleBar: {
    width: '100%',
    background: 'white',
  },
  titleBarTitle: {
    fontSize: rem(1.1),
    color: themeColor.primaryMain,
    fontFamily: 'Roboto',
  },
  titleBarTitleContainer: {
    padding: '1%',
  },
  icon: {
    padding: '1%',
  },
  inputContainer: {
    width: '400px',
    padding: '2% 0',
  },
  textFieldUnderline: {
    '&:after': {
      borderBottom: `2px solid ${theme.palette.secondary.main}`,
    },
    '&:hover:not($disabled):not($focused):not($error):before': {
      borderBottom: `2px solid ${theme.palette.secondary.main}`,
    },
  },
  inputLabel: {
    '&.Mui-focused': {
      color: themeColor.defaultTextColor,
    },
  },
  fullWidthInput: {
    width: '100%',
  },
  inputsContainer: {
    height: '70%',
  },
  dividerContainer: {
    height: '100%',
    paddingTop: '80px',
    paddingLeft: '46px',
    '@media(width:1024px) and (height:576px)': {
      paddingLeft: '80px',
    },
    '@media(width:1024px) and (height:768px)': {
      paddingLeft: '78px',
    },
    '@media(width:1920px) and (height:1080px)': {
      paddingLeft: '1px',
    },
  },
  divider: {
    height: '65%',
  },
  cancelButton: {
    marginRight: '1%',
  },
}));
